export default __webpack_public_path__ + "static/media/editHeaderCurv.a6a19323.svg";